/**
 * 备注
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import ContentBlock from '@/components/Reservation/ContentBlock';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/directRenewal';

import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { remarkInfo } = state;
  return { remarkInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { remarkInfo } = props;
  return (
    <div>
      <ContentBlock
        title={intl.get('app_reservation_reserve_remark')}
        className={styles.remarkInfoContainer}
      >
        <div className={styles.remarkContent}>
          {remarkInfo.remark || intl.get('drawer_extension_remark_content_null')}
        </div>
      </ContentBlock>
      <ContentBlock
        title={intl.get('app_reservation_checkin_remark')}
        className={styles.remarkInfoContainer}
      >
        <div className={styles.remarkContent}>
          {remarkInfo.checkInRemark || intl.get('drawer_extension_remark_content_null')}
        </div>
        <div className={styles.operationHintText}>
          <p>{intl.get('drawer_extension_remark_message_p1')}</p>
          <p>{intl.get('drawer_extension_remark_message_p2')}</p>
          <p>{intl.get('drawer_extension_remark_message_p3')}</p>
        </div>
      </ContentBlock>
    </div>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
